import { useParams } from "@solidjs/router";
import { useToast } from "../components/MessageBox";
import { useSFetch } from "../hooks/sfetch";
import { createSignal, onMount } from "solid-js";
import { Command } from "./MyCommands";
import Text from "../components/Text";
import { firstError } from "../api/envelope";
import { useTranslation } from "../hooks/useTranslation";


export function CommandPage(){
    const params = useParams();
    const toast = useToast();
    const sfetch = useSFetch();
    const { t } = useTranslation();

    const [command, setCommand] = createSignal<Command>();
    const [submitLoading, setSubmitLoading] = createSignal(false);

    onMount(async () => {
        let command = await sfetch("/api/GrantedUsers/CommandPrefab/" + params.id);
        setCommand(command.value);
    });

    async function submit(e: Event) {
        e.preventDefault();
        setSubmitLoading(true);
        const data = await sfetch("/api/GrantedUsers/CommandPrefab", {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(command())
        });
        setSubmitLoading(false);
        if (data.ok) {
            toast?.info(t("COMMAND_UPDATED"));
        } else {
            toast?.error(firstError(data) ?? t("COMMAND_UPDATE_FAILED"));
        }
    }

    return (
        <div class="dashboard-page">
            <h1><Text val="EDIT_COMMAND" /></h1>
            <form onSubmit={submit} class="form">
                <div class="form-group">
                    <label class="label" for="name"><Text val="NAME" /></label>
                    <input type="text" id="name" value={command()?.name} onInput={(e) => setCommand({...command(), name: e.currentTarget.value} as any)} />
                </div>
                <div class="form-group">
                    <label class="label" for="template"><Text val="TEMPLATE" /></label>
                    <input type="text" id="template" value={command()?.template} onInput={(e) => setCommand({...command(), template: e.currentTarget.value} as any)} />
                </div>
                <div class="form-group">
                    <label for="onlyPrefix"><Text val="ONLYPREFIX" /></label>
                    <input type="checkbox" id="onlyPrefix" checked={command()?.onlyPrefix} onChange={(e) => setCommand({...command(), onlyPrefix: e.currentTarget.checked} as any)} />
                </div>
                <button type="submit" class="btn btn-primary" disabled={submitLoading()}>{submitLoading() ? '...' : <Text val="SUBMIT" />}</button>
            </form>
        </div>
    );
}